import React from 'react'
import { ComponentExt } from 'util/reactExt'
import { RouteComponentProps, Link } from 'react-router-dom'
import { inject, observer } from 'mobx-react'
import Cate from 'components/layout/CateLayout'
import Card from 'components/Card'
import { Pagination } from 'antd'
import Breadcrumb from 'components/Breadcrumb'
import styles from './index.scss'

const typeMap = {
  article: '文章',
  topic: '专题',
  course: '视频',
}

interface SearchResultDetailProps extends RouteComponentProps<any> {
  globalStore: IGlobalStore.GlobalStore
  searchStore: ISearchStore.SearchStore
}

@inject('globalStore', 'searchStore')
@observer
class SearchResultDetail extends ComponentExt<SearchResultDetailProps> {
  state = {
    currentPageIndex: 1,
    searchResultlist: {
      data: [],
      total: 0,
    },
  }

  componentDidMount() {
    const q = new URLSearchParams(this.props.location.search).get('q')
    this.props.searchStore.setSearchKeyWords(q)
    this.fetchSearchResultList(1)
  }

  toDetail(id, type, isTopic) {
    const { history } = this.props
    if (isTopic) {
      return history.push({
        pathname: `/topicdetail/${id}`,
      })
    }
    window.open(`#/course/${id}?type=${type}`)
  }

  handlePageChange(pageindex) {
    this.fetchSearchResultList(pageindex)
    window.scrollTo(0, 150)
    this.setState({
      currentPageIndex: pageindex,
    })
  }

  async fetchSearchResultList(pageindex) {
    const res = await this.api.search.search({
      key_word: this.searchKeyWords,
      type: this.type,
      pageindex,
      pagesize: 10,
      sort: 0,
    })

    this.setState({
      searchResultlist: res[this.type],
    })
  }

  get type() {
    return new URLSearchParams(this.props.location.search).get('t')
  }

  get searchKeyWords() {
    return this.props.searchStore.searchKeyWords
  }

  render() {
    const { currentPageIndex, searchResultlist } = this.state
    const q = new URLSearchParams(this.props.location.search).get('q')
    return (
      <div>
        <div className={styles.safe}>
          <Breadcrumb
            data={[
              { name: '学院首页', url: '/' },
              { name: '搜索结果', url: `/searchresult?q=${q}` },
              { name: typeMap[this.type], url: '' },
            ]}
          />
        </div>
        <Cate
          title={
            <h3 className={styles.setcionTitle}>
              共有<span>{searchResultlist.total}</span>门包含“<span>
                {this.searchKeyWords || '汪总'}
              </span>”的{typeMap[this.type]}
            </h3>
          }
          type={this.type === 'topic' ? 4 : 5}
        >
          {searchResultlist.total > 0 &&
            searchResultlist.data.map(
              ({ id, type, title, img_url, view_count, course_time }) => (
                <React.Fragment key={id}>
                  <Card
                    title={title}
                    cover={img_url}
                    type={this.type === 'topic' ? 'middle' : 'small'}
                    time={course_time}
                    onClick={() =>
                      this.toDetail(id, type, this.type === 'topic')
                    }
                    watch={view_count}
                  />
                </React.Fragment>
              ),
            )}
        </Cate>
        <Pagination
          style={{
            borderTop: '1px solid #ddd',
            padding: '20px 0',
            textAlign: 'center',
          }}
          hideOnSinglePage={true}
          current={currentPageIndex}
          onChange={pageindex => this.handlePageChange(pageindex)}
          total={searchResultlist.total}
        />
      </div>
    )
  }
}

export default SearchResultDetail
